import { Icon } from '@iconify/react';
import { MIconButton } from 'components';
import { SnackbarMessage, useSnackbar, VariantType, WithSnackbarProps } from 'notistack';
// material
// @types

let useSnackbarRef: WithSnackbarProps;
export const SnackbarUtilsConfigurator: React.FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

/**
 * Show a toast message with the AutoHideDuration (5 secs)
 * @param message Message to display
 * @param variant which type of variant
 */

export function showMessage(message: SnackbarMessage, variant: VariantType) {
  if (useSnackbarRef && useSnackbarRef.enqueueSnackbar) {
    useSnackbarRef.enqueueSnackbar(message, {
      variant: variant,
      action: (key) => (
        <MIconButton size="small" onClick={() => useSnackbarRef.closeSnackbar(key)}>
          <Icon icon={'eva:close-fill'} />
        </MIconButton>
      )
    });
  }
}
